import { IconCollection } from "components/Icon/IconCollection";
import { ResourceConfig } from "config/config";
import {
    deleteActionSignature,
    DeleteListAction,
    deletePermanentlyActionSignature,
    duplicateActionSignature,
    exportActionSignature,
    moveToLocationActionSignature,
    PermanentlyDeleteListAction,
} from "containers/Resources/components/CommonActions/CommonActions";
import {
    commentsTab,
    logsTab,
    logsTabKey,
    metadataTab,
    referencesUsedByTab,
} from "containers/Resources/screens/ResourcesSingle/constants";
import resource from "./resource";

const commonGraphqlBody = `
    ${resource.graphql.resourceBody}
    role_administrator
    zone_administrator
    egress_administrator
`;

const resourceName = "role";

const config: ResourceConfig = {
    label: "Role",
    icon: IconCollection.badge,
    resourceName,
    resourceClass: "resource",
    defaultActiveTab: logsTabKey,
    graphql: {
        resource: resourceName,
        resourceBody: `
            ${commonGraphqlBody}
            role_permission_list_role_id(limit:10, offset:0, order: "+operation",){
                role_permission_count
                role_permission_list {
                    id
                    project_id
                    project_id_project{
                        name
                    }
                    table_type
                    operation
                    object_template_id
                    object_template_id_object_template{
                        name
                    }
                    zone_id
                    zone_id_zone{
                        name
                    }
                    role_id_role{
                        deleted_at
                        is_readonly
                    }
                }
            }
        `,
        resourceSingleQueryBody: `
            ${commonGraphqlBody}
            role_permission_list_role_id(limit:$rolePermissionLimit, order: $rolePermissionOrder, offset: $rolePermissionOffset){
                role_permission_count
                role_permission_list {
                    id
                    project_id
                    project_id_project{
                        name
                    }
                    table_type
                    operation
                    object_template_id
                    object_template_id_object_template{
                        name
                    }
                    zone_id
                    zone_id_zone{
                        name
                    }
                    role_id_role{
                        deleted_at
                        is_readonly
                    }
                }
            }
        `,
        resourceBodyListing: `
            ${resource.graphql.resourceBody}
        `,
        createVariables: `
            ${resource.graphql.createVariables(resourceName)}
            $role_administrator: Boolean,
            $zone_administrator: Boolean,
            $egress_administrator: Boolean,
        `,
        createQuery: `
            ${resource.graphql.createQuery(resourceName)}
            role_administrator: $role_administrator,
            zone_administrator: $zone_administrator,
            egress_administrator: $egress_administrator,
        `,
        updateVariables: `
            ${resource.graphql.updateVariables(resourceName)}
            $role_administrator: Boolean,
            $zone_administrator: Boolean,
            $egress_administrator: Boolean,
        `,
        updateQuery: `
            ${resource.graphql.updateQuery(resourceName)}
            role_administrator: $role_administrator,
            zone_administrator: $zone_administrator,
            egress_administrator: $egress_administrator,
        `,
        singleQueryVariables: `
            $rolePermissionLimit: Int,
            $rolePermissionOffset: Int,
            $rolePermissionOrder: String,`,
    },
    layout: [
        {
            partial: "pageHeaderForm",
        },
        { partial: "form" },
        { partial: "roleIdentityList" },
        { partial: "rolePermissionList" },
        {
            partial: "tabs",
            config: {
                tabs: [logsTab.tab, commentsTab.tab, referencesUsedByTab.tab, metadataTab.tab],
                content: [
                    logsTab.content,
                    commentsTab.content,
                    referencesUsedByTab.content,
                    metadataTab.content,
                ],
            },
        },
    ],
    form: [
        {
            name: "role_administrator",
            component: "switch",
            fieldProps: {
                label: "Role administrator",
                defaultValue: false,
                docs: {
                    text: "Members can create, change and delete roles and their permissions, and assign any role to any identity. Only a role administrator can change this setting.",
                    urlPath: "/docs/security/rbac#role-zone-and-egress-administration",
                },
            },
        },
        {
            name: "zone_administrator",
            component: "switch",
            fieldProps: {
                label: "Zone administrator",
                defaultValue: false,
                docs: {
                    text: "Members can create, change and delete permission zones, grant roles access into a zone, and reach every zone. Only a zone administrator can change this setting.",
                    urlPath: "/docs/security/rbac#role-zone-and-egress-administration",
                },
            },
        },
        {
            name: "egress_administrator",
            component: "switch",
            fieldProps: {
                label: "Egress administrator",
                defaultValue: false,
                docs: {
                    text: "Members can create, change and delete egress policies, which decide where connections may send data. Only an egress administrator can change this setting.",
                    urlPath: "/docs/security/rbac#role-zone-and-egress-administration",
                },
            },
        },
    ],
    actions: {
        shown: [],
        hidden: [
            duplicateActionSignature,
            exportActionSignature,
            moveToLocationActionSignature,
            deleteActionSignature,
            deletePermanentlyActionSignature,
        ],
    },
    listActions: {
        shown: [],
        hidden: [
            { key: "delete", action: DeleteListAction },
            { key: "deletePermanently", action: PermanentlyDeleteListAction },
        ],
    },
};
export default config;
